import _regeneratorRuntime from "@babel/runtime/regenerator";

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(createFormSagaWorker),
    _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(createFormSagaWatcher),
    _marked3 = /*#__PURE__*/_regeneratorRuntime.mark(updateFormSagaWorker),
    _marked4 = /*#__PURE__*/_regeneratorRuntime.mark(updateFormSagaWatcher),
    _marked5 = /*#__PURE__*/_regeneratorRuntime.mark(deleteFormSagaWorker),
    _marked6 = /*#__PURE__*/_regeneratorRuntime.mark(deleteFormSagaWatcher),
    _marked7 = /*#__PURE__*/_regeneratorRuntime.mark(formsSaga);

import { all, fork, put, takeLatest } from 'redux-saga/effects';
import { CREATE_FORM_STATE_ASYNC, DELETE_FORM_STATE_ASYNC, UPDATE_FORM_STATE_ASYNC } from './forms.action-types';
import { actions } from './forms.actions';

/**
 * Create form saga worker.
 *
 * @author Mikhail Siutsou
 * @function createFormSagaWorker
 * @category Sagas
 * @subcategory Forms
 * @return {Generator<PutEffect>} action data.
 */
function createFormSagaWorker(action) {
  return _regeneratorRuntime.wrap(function createFormSagaWorker$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return put(actions.createForm(action.payload));

        case 2:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}
/**
 * Create form to saga watcher.
 *
 * @author Mikhail Siutsou
 * @function createFormSagaWatcher
 * @category Sagas
 * @subcategory Forms
 * @return {Generator<AllEffect<ForkEffect>>} data.
 */


function createFormSagaWatcher() {
  return _regeneratorRuntime.wrap(function createFormSagaWatcher$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return all([takeLatest(CREATE_FORM_STATE_ASYNC, createFormSagaWorker)]);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}
/**
 * Update form saga worker.
 *
 * @author Mikhail Siutsou
 * @function updateFormSagaWorker
 * @category Sagas
 * @subcategory Forms
 * @return {Generator<PutEffect>} action data.
 */


function updateFormSagaWorker(action) {
  return _regeneratorRuntime.wrap(function updateFormSagaWorker$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return put(actions.updateFormState(action.payload));

        case 2:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}
/**
 * Update form to saga watcher.
 *
 * @author Mikhail Siutsou
 * @function updateFormSagaWatcher
 * @category Sagas
 * @subcategory Forms
 * @return {Generator<AllEffect<ForkEffect>>} data.
 */


function updateFormSagaWatcher() {
  return _regeneratorRuntime.wrap(function updateFormSagaWatcher$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return all([takeLatest(UPDATE_FORM_STATE_ASYNC, updateFormSagaWorker)]);

        case 2:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4);
}
/**
 * Delete form saga worker.
 *
 * @author Mikhail Siutsou
 * @function deleteFormSagaWorker
 * @category Sagas
 * @subcategory Forms
 * @return {Generator<PutEffect>} action data.
 */


function deleteFormSagaWorker(action) {
  return _regeneratorRuntime.wrap(function deleteFormSagaWorker$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return put(actions.deleteFormState(action.payload));

        case 2:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5);
}
/**
 * Delete form to saga watcher.
 *
 * @author Mikhail Siutsou
 * @function createFormSagaWatcher
 * @category Sagas
 * @subcategory Forms
 * @return {Generator<AllEffect<ForkEffect>>} data.
 */


function deleteFormSagaWatcher() {
  return _regeneratorRuntime.wrap(function deleteFormSagaWatcher$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return all([takeLatest(DELETE_FORM_STATE_ASYNC, deleteFormSagaWorker)]);

        case 2:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6);
}
/**
 * Forms saga.
 *
 * @author Mikhail Siutsou
 * @function formsSaga
 * @category Sagas
 * @subcategory Forms
 * @return {Generator<AllEffect<ForkEffect>>} data.
 */


export default function formsSaga() {
  return _regeneratorRuntime.wrap(function formsSaga$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return all([fork(createFormSagaWatcher), fork(updateFormSagaWatcher), fork(deleteFormSagaWatcher)]);

        case 2:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked7);
}